import React from "react";
import "./Footer.css";

const Footer = () => {
  return <div className='footer'>© The Think Tank</div>;
};

export default Footer;
